import React, { useState } from "react";
import axios from "../../api/axios";
import ReportFilter from "./components/ReportFilter";

const PropertyWiseReport = () => {
  const [filters, setFilters] = useState({});
  const [data, setData] = useState([]);

  const fetchReport = async () => {
    const res = await axios.get("/api/reports/property-wise", {
      params: filters,
    });
    setData(res.data.data || []);
  };

  const downloadCSV = async () => {
    const res = await axios.get("/api/reports/property-wise/csv", {
      params: filters,
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "property-wise-report.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const downloadPDF = async () => {
    const res = await axios.get("/api/reports/property-wise/pdf", {
      params: filters,
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "property-wise-report.pdf");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <div className="container py-4">
      <h4 className="fw-bold mb-3">Property Wise Report</h4>

      <ReportFilter
        filters={filters}
        setFilters={setFilters}
        onSearch={fetchReport}
      />

      <div className="card shadow-sm">
        <div className="card-body">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Property</th>
                <th>Area</th>
                <th>Type</th>
                <th>Total Units</th>
                <th>Available</th>
                <th>Booked</th>
                <th>Sold</th>
                <th>Revenue</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    No data yet. Run a search to load the report.
                  </td>
                </tr>
              ) : (
                data.map((row) => (
                  <tr key={row.property_id}>
                    <td>{row.property_name}</td>
                    <td>{row.area}</td>
                    <td>{row.type}</td>
                    <td>{row.total_units}</td>
                    <td>{row.available}</td>
                    <td>{row.booked}</td>
                    <td>{row.sold}</td>
                    <td>{Number(row.revenue).toFixed(2)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div className="text-end">
            <button className="btn btn-danger" onClick={downloadPDF}>
              PDF Download
            </button>
            <button className="btn btn-secondary ms-2" onClick={downloadCSV}>
              CSV Download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyWiseReport;
